/**
 * Posledný materiálový slot, ktorý používateľ vyberal — nový dielec
 * (quick add) ho dostane ako default. Per varianta v localStorage.
 */

const KEY = (variantaId: string): string => `tandem_last_slot_${variantaId}`;

export function setLastSlot(variantaId: string, slotId: string | null): void {
  try {
    if (slotId) localStorage.setItem(KEY(variantaId), slotId);
    else localStorage.removeItem(KEY(variantaId));
  } catch {
    // private mode / plné úložisko — default jednoducho nebude
  }
}

export function getLastSlot(variantaId: string): string | null {
  try {
    return localStorage.getItem(KEY(variantaId));
  } catch {
    return null;
  }
}
